import * as THREE from 'three';
import ClipperLib from 'clipper-lib';
import { fromClip, CLIP_SCALE } from './windowShapes';
import { clippedGrillePaths } from './fixedGrilleClipping';

export function addFixedGrilles(group, design, frame) {
  const paths = clippedGrillePaths(design); if (!paths.length) return;
  const union = new ClipperLib.Clipper(), tree = new ClipperLib.PolyTree();
  union.AddPaths(paths, ClipperLib.PolyType.ptSubject, true);
  union.Execute(ClipperLib.ClipType.ctUnion, tree, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
  const shapes = [];
  const visit = node => {
    if (node.Contour().length && !node.IsHole()) {
      const shape = new THREE.Shape(fromClip(node.Contour()).map(([x, y]) => new THREE.Vector2(x, y)));
      node.Childs().filter(child => child.IsHole()).forEach(child => shape.holes.push(new THREE.Path(fromClip(child.Contour()).map(([x, y]) => new THREE.Vector2(x, y)))));
      shapes.push(shape);
    }
    node.Childs().forEach(visit);
  };
  visit(tree);
  const bars = new THREE.Mesh(new THREE.ExtrudeGeometry(shapes, { depth: .016, bevelEnabled: false, steps: 1 }), frame);
  bars.position.z = -.008; bars.castShadow = true; bars.name = 'fixed-window-clipped-grilles';
  bars.userData.dividerBars = true;
  bars.userData.dividerCount = Number(design.dividers.horizontal) + Number(design.dividers.vertical);
  bars.userData.clippedArea = paths.reduce((a, path) => a + ClipperLib.Clipper.Area(path), 0) / CLIP_SCALE ** 2;
  group.add(bars);
}